import ViewFundApplication from "src/components/feature/ViewFundApplication";

const DefaultViewFundApplication = () => {
  return <ViewFundApplication />;
};

export default DefaultViewFundApplication;
